import { render } from "./WindowPopupNotification.vue?vue&type=template&id=30f00d7e&ts=true"
import script from "./WindowPopupNotification.ts?vue&type=script&lang=ts&external"
export * from "./WindowPopupNotification.ts?vue&type=script&lang=ts&external"

import "./WindowPopupNotification.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__